import React from "react";
import {
  type FieldArrayRenderProps,
  type FormikErrors,
  type FormikTouched
} from "formik";
import { type Config, TokenHistoryLabel } from "kadow-jetpack-model";
import DraggableCTAs from "./module/DraggableCTA";
import CTACard from "./module/CTACard";

interface RegularCTAsEditorProps {
  displayRegularCTAs: boolean;
  config: Config;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, value: any) => void;
  errors: FormikErrors<Config>;
  touched: FormikTouched<Config>;
  canRemoveCTA: boolean;
  regularCTAsToDisplay: TokenHistoryLabel[];
  arrayHelpers: FieldArrayRenderProps;
}

const RegularCTAsEditor: React.FC<RegularCTAsEditorProps> = (props) => {
  if (!props.displayRegularCTAs) {
    return null;
  }

  return (
    <>
      <div className="w-100">
        <DraggableCTAs
          CTAs={props.config.ctas}
          setFieldValue={props.setFieldValue}
          config={props.config}
          arrayHelpers={props.arrayHelpers}
          errors={props.errors}
          touched={props.touched}
          canRemoveCTA={props.canRemoveCTA}
        />
      </div>
      <div className="cta-card-container w-100">
        {props.regularCTAsToDisplay?.map((cta, idx) => {
          if (cta === TokenHistoryLabel.CustomForm) {
            return null;
          }
          return (
            <CTACard
              key={`cta-${cta}-${idx}`}
              ctaId={cta}
              setFieldValue={props.setFieldValue}
              setFieldTouched={props.setFieldTouched}
              config={props.config}
              isSelected={false}
            />
          );
        })}
      </div>
    </>
  );
};

export default RegularCTAsEditor;
